import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { RolsService } from '../../../../core/repositories/rols.service';
import { Rols } from '../../../../core/entities/rols.model';
import { SelectItem } from 'primeng/api';
import { Utils } from 'src/app/core/utils/utils';
import * as _ from 'lodash';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { PETICIONES, STORAGE } from 'src/app/core/utils/constants';
import { PersonsByIdNumCtrlDig } from 'src/app/core/entities/personsByIdNumCtrlDig.model';
import { DialogsAlertComponent } from '../dialogs-alert/dialogs-alert.component';


@Injectable()
export class DialogsBuscadorService {

    rols: Rols = new Rols();
    allRols: Rols[] = [];
    rolesLDAP: String[] = new Array<String>();
    allPersons: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();
    nif: string = "";

    optionsRols: SelectItem[] = [];
    optionsRolsBase: SelectItem[] = [];

    loginInterno: any;

    constructor(private rolsService: RolsService, 
                private repositoryService: RepositoryService,
                private translateService: TranslateService,
                private dialog: MatDialog) { }

    init(data: any): Observable<boolean> {
        let roles = localStorage.getItem(STORAGE.ALLROLS) ?? "";
        this.rolesLDAP = JSON.parse(roles);
        console.log(data);      
        return this.rolsService.findAll().pipe(map((result: Rols[]) => {
            this.optionsRolsBase.push({ value: null, label: "" });
            this.allRols = result;

            let include = this.rolesLDAP.includes('ROLE_carpeta_fi4admin');

            if(include){
                for (let i = 0; i < this.allRols.length; i++) {
                    this.optionsRolsBase.push({ value: this.allRols[i].code, label: this.allRols[i].desc });
                }
            }else{
                for (let i = 0; i < this.allRols.length; i++) {
                    for(let x = 0; x < this.rolesLDAP.length; x++){
                        if(this.allRols[i].rolldap === this.rolesLDAP[x]){
                            this.optionsRolsBase.push({ value: this.allRols[i].code, label: this.allRols[i].desc });
                        }
                    }
                }
            }
            this.optionsRols = this.optionsRolsBase;
            this.optionsRolsBase = [];
            return true;
        }),catchError((error: any) => {
            console.log(error);
            throw error;
        }));
    }

    /**
    * @description
    * Deshabilita o habilita el botón aceptar
    */
    deshabilitar() {
        if ((Utils.noUndfAndNull(this.rols.code) && this.rols.code !== "null")
            && (Utils.noUndfAndNull(this.nif) && this.nif !== "")) {
            return false;
        } else {
            return true;
        }
    }

    /**
    * @description
    * Nos da los terceros que tiene la empresa o proveedor
    * @param nif CIF
    */
    public getTerceros(nif: string): Observable<PersonsByIdNumCtrlDig[]> {
        return this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif).pipe(map((result: any) => {
            this.allPersons = _.cloneDeep(result.personsByIdNumCtrlDig);
            return this.allPersons;
        }),catchError((error: any) => {
            this.errorCargaWS('WARNINGS.error_ws');
            throw error;
        }));
    }

    /**
    * @description
    * No dice si el usuario o empresa que buscamos es proveeodr o no
    */
    public isProveedor(): Observable<any>{
        return this.repositoryService.doGet(PETICIONES.webservice.doGetProveidors + "/" + this.nif).pipe(map((result: boolean) => {
            return result;
        }),catchError((error: any) => {
            console.log(error);
            throw error;
        }));
    }

    /**
    * @description
    * Abre un cuadro de dialogo para informar de un error
    * @param error Texto a mostrar
    */
    public errorCargaWS(error: string) {
            const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: this.translateService.instant(error) }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    build() {
        this.rols = new Rols();
    }
}
